import type { SVGProps } from 'react';
const SvgNavParking = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    height={24}
    fill="none"
    width={24}
    {...props}
  >
    <path
      d="M10 15v4q0 .824-.588 1.413A1.93 1.93 0 0 1 8 21q-.824 0-1.412-.587A1.93 1.93 0 0 1 6 19V5q0-.824.588-1.412A1.93 1.93 0 0 1 8 3h5q2.5 0 4.25 1.75T19 9t-1.75 4.25T13 15zm0-4h3.2q.824 0 1.413-.588Q15.2 9.826 15.2 9t-.587-1.412A1.93 1.93 0 0 0 13.2 7H10z"
      fill="currentColor"
    />
  </svg>
);
export default SvgNavParking;
